import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { FilteredSaleOrder } from '../../services/load-management.service';

@Component({
  selector: 'app-sales-orders-table',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatCheckboxModule,
    MatCardModule,
    MatIconModule,
    DragDropModule,
    FormsModule
  ],
  templateUrl: './sales-orders-table-component.html',
  styleUrls: ['./sales-orders-table-component.scss']
})
export class SalesOrdersTableComponent {
  @Input() orders: FilteredSaleOrder[] = [];
  allSelected: boolean = false;
  @Output() ordersChange = new EventEmitter<FilteredSaleOrder[]>();
  @Output() openOrder = new EventEmitter<FilteredSaleOrder>();

  allColumns = ['dragHandle', 'serial', 'select', 'name', 'customerName', 'salesmanName', 'numberOfItems', 'totalAmount'];

  onToggleAll() {
    this.orders.forEach(order => {
      order.selected = this.allSelected;
    });
  }

  onSelectOrder(order: FilteredSaleOrder) {
    this.allSelected = this.orders.every(o => o.selected);
  }

  onDrop(event: CdkDragDrop<any[]>) {
    const reordered = [...this.orders];
    moveItemInArray(reordered, event.previousIndex, event.currentIndex);
    this.updateOrders(reordered);
  }

  updateOrders(updatedOrders: any[]) {
    this.orders = updatedOrders;
    this.ordersChange.emit(this.orders); // Emit the updated orders array back to the parent
  }
}
